var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{ref:"myVueDropzone",class:_vm.customClass,attrs:{"id":"dropzone","options":_vm.dropzoneOptions}})}
var staticRenderFns = []
export { render, staticRenderFns }